/* Packages */
import React, {lazy, Suspense} from 'react';
import {render} from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

/* Components */
const Favorites = lazy(() => import(/* webpackChunkName: "Favorites" */ './components/Favorites'));

const favorites = document.getElementById('favorites');
if (favorites != null) {
    const props = parseDatasetToProps(favorites.dataset);
	render(
        <Suspense fallback={<></>}>
            <Favorites {...props} updateUrl={props.favoriteUpdateUrl} />
        </Suspense>,
        favorites
    );
}
